<template>
  <el-container>
    <el-header>
      <common-header @changeLanguage="loadDict"/>
    </el-header>
    <div class="banner banner1">
      <div class="maincontainer">
        <div class="icon"></div>
        <div class="title">{{ $t('lang.confirmInfo.pleaseConfirmYourInfo') }}</div>
      </div>
    </div>
    <el-main>
      <div class="maincontainer" style="padding:20px 0;">
        <el-form ref="form" :model="formData" :label-width="isZh ? '120px' : '230px'" size="mini" :rules="rules">
          <el-row>
            <el-col :span="18" :offset="4">
              <el-form-item :label="$t('lang.confirmInfo.name')" prop="name">
                <el-input v-model="formData.name" :disabled="disablePersonalInfo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18" :offset="4">
              <el-form-item :label="$t('lang.confirmInfo.email')" prop="email">
                <el-input v-model="formData.email" :disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18" :offset="4">
              <el-form-item :label="$t('lang.confirmInfo.studentNo')" prop="studentNo">
                <el-input v-model="formData.studentNo" :disabled="disablePersonalInfo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18" :offset="4">
              <el-form-item :label="$t('lang.confirmInfo.mobile')" prop="mobile">
                <el-input v-model="formData.mobile" :disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18" :offset="4">
              <el-form-item :label="$t('lang.confirmInfo.birthday')" prop="birthday">
                <el-date-picker type="date" :placeholder="$t('lang.common.chooseDate')" v-model="formData.birthday"
                                :default-value="new Date(1990, 0)"
                                style="width: 100%;" :disabled="disablePersonalInfo"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18" :offset="4">
              <el-form-item :label="$t('lang.confirmInfo.gender')" prop="gender">
                <el-select v-model="formData.gender" :placeholder="$t('lang.common.pleaseSelect')" :disabled="disabled"
                           style="width: 100%;">
                  <el-option :label="$t('lang.confirmInfo.genders.male')" value="MALE"></el-option>
                  <el-option :label="$t('lang.confirmInfo.genders.female')" value="FEMALE"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18" :offset="4">
              <el-form-item :label="$t('lang.confirmInfo.idType')" prop="idType">
                <el-select v-model="formData.idType" :placeholder="$t('lang.common.pleaseSelect')" :disabled="disabled"
                           style="width: 100%;">
                  <el-option :label="$t('lang.confirmInfo.idTypes.idCard')" value="ID_CARD"></el-option>
                  <el-option :label="$t('lang.confirmInfo.idTypes.passport')" value="PASSPORT"></el-option>
                </el-select>

              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14" :offset="4">
              <el-form-item
                :label="formData.idType && formData.idType === 'PASSPORT' ? $t('lang.confirmInfo.passportNo') : $t('lang.confirmInfo.idNo')"
                prop="idNo">
                <el-input v-model="formData.idNo" :disabled="disablePersonalInfo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4" style="display: flex; justify-content: space-around;">
              <el-button type="ceibsprimary" size="mini" @click="openDrawer" v-if="!disablePersonalInfo">
                {{ $t('lang.confirmInfo.upload.btn') }}
              </el-button>
              <el-button :type="drawerFileList.length > 0 ? 'ceibsprimary' : 'ceibs'" size="mini" @click="openPreview">
                {{ $t('lang.confirmInfo.upload.previewBtn') }}
              </el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18" :offset="4">
              <el-form-item :label="$t('lang.confirmInfo.course')" prop="courseId">
                <el-select v-model="formData.courseId" :placeholder="$t('lang.common.pleaseSelect')"
                           :disabled="disabled"
                           style="width: 100%;">
                  <el-option v-for="item in courseList" :key="item.id" :label="item.code" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18" :offset="4">
              <el-form-item :label="$t('lang.confirmInfo.currentStatus')" prop="studentStatusCode">
                <el-select v-model="formData.studentStatusCode" :placeholder="$t('lang.common.pleaseSelect')"
                           :disabled="disabled"
                           style="width: 100%;">
                  <el-option v-for="item in studentStatusList" :key="item.code" :label="item.name"
                             :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18" :offset="4">
              <el-form-item :label="$t('lang.confirmInfo.applyType')" prop="applyType">
                <el-select v-model="formData.applyType" :placeholder="$t('lang.common.pleaseSelect')"
                           :disabled="disabled"
                           style="width: 100%;">
                  <el-option :label="$t('lang.confirmInfo.applyTypes.electronic')" value="ELECTRONIC"></el-option>
                  <el-option :label="$t('lang.confirmInfo.applyTypes.paper')" value="PAPER"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-col :offset="8" :span="8" style="padding-top:30px">
            <el-button size="mini" type="ceibsprimary" style="width: 100%" @click="submit('form')">
              {{ $t('lang.common.goNext') }}
            </el-button>
          </el-col>
        </el-form>
      </div>
    </el-main>
    <el-drawer
      :visible.sync="drawerVisible"
      direction="rtl">
      <div slot="title" class="dialogtitle">{{ $t('lang.confirmInfo.idPhoto') }}</div>
      <el-upload action="https://jsonplaceholder.typicode.com/posts/"
                 drag
                 multiple
                 list-type="picture"
                 :http-request="doUpload"
                 :on-remove="onRemove"
                 :limit="2"
                 :file-list="drawerFileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">{{ $t('lang.common.uploadTip') }}</div>
        <div class="el-upload__tip" slot="tip">
          {{ $t('lang.confirmInfo.upload.pleaseUploadImage') }}
        </div>
      </el-upload>
    </el-drawer>
    <el-dialog
      :visible.sync="previewVisible"
      custom-class="ceibsdialog"
      width="650px"
      :title="$t('lang.confirmInfo.upload.previewBtn')"
      :center="true">
      <el-carousel :interval="5000" arrow="always" height="400px">
        <el-carousel-item v-for="(item, index) in drawerFileList" :key="index">
          <el-image :src="item.url" fit="contain"></el-image>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
  </el-container>
</template>

<script>
import CommonHeader from '@/components/common/commonHeader'
import { mapGetters } from 'vuex'
import languageType from '@/locales/languageType'
import { getFile, getFileByFileUrl, listAllCourse, listDictByType, uploadFile } from '@/api/base'
import { find, lastApply, loadStudentInfo, submitAndCreateApply } from '@/api/apply'
import { checkImgType } from '@/util/util.file'
import { getAccessToken } from '@/util/util.ruquest'

export default {
  name: 'ConfirmInfo',
  components: { CommonHeader },
  data () {
    return {
      previewVisible: false,
      drawerVisible: false,
      drawerFileList: [],
      formData: {
        applyType: null,
        applyPurposeCode: null,
        applyPurposeDesc: null,
        name: null,
        email: null,
        studentNo: null,
        mobile: null,
        birthday: null,
        idType: null,
        idNo: null,
        gender: null,
        courseId: null,
        studentStatusCode: null
      },
      idTypes: [
        {
          code: 'ID_CARD',
          name: '身份证'
        },
        {
          code: 'PASSPORT',
          name: '护照'
        }
      ],
      courseList: [],
      studentStatusList: [],
      applyPurposeList: [],
      disabled: false,
      rules: {
        name: [{
          required: true,
          message: this.$t('lang.confirmInfo.validate.name'),
          trigger: 'blur'
        }],
        email: [{
          required: true,
          message: this.$t('lang.confirmInfo.validate.email'),
          trigger: 'blur'
        }],
        studentNo: [{
          required: true,
          message: this.$t('lang.confirmInfo.validate.studentNo'),
          trigger: 'blur'
        }],
        mobile: [{
          required: true,
          message: this.$t('lang.confirmInfo.validate.mobile'),
          trigger: 'blur'
        }],
        birthday: [{
          required: true,
          message: this.$t('lang.confirmInfo.validate.birthday'),
          trigger: 'blur'
        }],
        idType: [{
          required: true,
          message: this.$t('lang.confirmInfo.validate.idType'),
          trigger: 'blur'
        }],
        idNo: [{
          required: true,
          message: this.$t('lang.confirmInfo.validate.idNo'),
          trigger: 'blur'
        }],
        gender: [{
          required: true,
          message: this.$t('lang.confirmInfo.validate.gender'),
          trigger: 'blur'
        }],
        courseId: [{
          required: true,
          message: this.$t('lang.confirmInfo.validate.courseId'),
          trigger: 'blur'
        }],
        studentStatusCode: [{
          required: true,
          message: this.$t('lang.confirmInfo.validate.studentStatus'),
          trigger: 'blur'
        }],
        applyType: [{
          required: true,
          message: this.$t('lang.confirmInfo.validate.applyType'),
          trigger: 'blur'
        }]
      },
      hasStudentInfo: false
    }
  },
  mounted () {
    if (this.currentApplyId) {
      this.loadApply(this.currentApplyId)
    } else {
      this.loadLastApplyOrStudentInfo()
    }
    this.loadCourseList()
    this.loadDict()
  },
  computed: {
    ...mapGetters([
      'currentLanguage',
      'currentApplyId'
    ]),
    disablePersonalInfo: function () {
      if (this.hasStudentInfo) {
        return true
      }
      return this.disabled
    },
    isZh: function () {
      return this.currentLanguage === languageType.zh.code
    }
  },
  inject: ['reload'],
  methods: {
    isLogin () {
      return getAccessToken()
    },
    loadCourseList () {
      listAllCourse().then(res => {
        this.courseList = res.data
      })
    },
    loadDict () {
      this.loadStudentStatusList()
      this.loadApplyPurposeList()
    },
    loadApplyPurposeList () {
      listDictByType({
        type: 'APPLY_PURPOSE'
      }).then(res => {
        this.applyPurposeList = res.data.map(dict => {
          return {
            code: dict.code,
            name: this.currentLanguage === languageType.zh.code ? dict.chineseName : dict.englishName
          }
        })
      })
    },
    loadStudentStatusList () {
      listDictByType({
        type: 'STUDENT_STATUS'
      }).then(res => {
        this.studentStatusList = res.data.map(dict => {
          return {
            code: dict.code,
            name: this.currentLanguage === languageType.zh.code ? dict.chineseName : dict.englishName
          }
        })
      })
    },
    loadLastApplyOrStudentInfo () {
      if (this.isLogin()) {
        lastApply().then(res => {
          if (res.data) {
            const lastApply = res.data
            this.formData.name = lastApply.name
            this.formData.email = lastApply.email
            this.formData.studentNo = lastApply.studentNo
            this.formData.mobile = lastApply.mobile
            this.formData.birthday = lastApply.birthdayStr
            this.formData.idType = lastApply.idType
            this.formData.idNo = lastApply.idNo
            this.formData.gender = lastApply.gender
            this.formData.courseId = lastApply.courseId
            this.formData.studentStatusCode = lastApply.studentStatusCode
          } else {
            loadStudentInfo().then(studentRes => {
              const studentInfo = studentRes.data
              if (studentInfo) {
                this.hasStudentInfo = studentInfo.CHINESE_NAME && studentInfo.EMAIL1 && studentInfo.STUDENT_ID && studentInfo.MOBILE && studentInfo.BIRTHDATE && studentInfo.GENDER && studentInfo.ID_PASSPORT
                this.formData.name = studentInfo.CHINESE_NAME
                this.formData.email = studentInfo.EMAIL1
                this.formData.studentNo = studentInfo.STUDENT_ID
                this.formData.mobile = studentInfo.MOBILE
                this.formData.birthday = studentInfo.birthDateStr
                this.formData.gender = studentInfo.GENDER === 'Male' ? 'MALE' : 'FEMALE'
                this.formData.idNo = studentInfo.ID_PASSPORT
                this.formData.idType = this.formData.idNo.length === 18 ? 'ID_CARD' : 'PASSPORT'
                const matchedCourse = this.courseList.filter(course => course.code === studentInfo.USER_TYPE)[0]
                if (matchedCourse) {
                  this.formData.courseId = matchedCourse.id
                }
              }
            })
          }
        })
      }
    },
    loadApply (applyId) {
      find({
        id: applyId
      }).then(res => {
        const applyVo = res.data
        if (applyVo.applyStatus === 'CANCELLED') {
          this.$message.info(this.$t('lang.toast.applyAlreadyCancelled'))
          this.$store.dispatch('removeCurrentApplyId')
          this.reload()
        } else if (applyVo.applyStatus !== 'DRAFT') {
          this.$confirm(this.$t('lang.toast.applyAlreadySubmit'), this.$t('lang.common.warning'), {
            type: 'warning',
            confirmButtonClass: 'el-button--ceibsprimary',
            cancelButtonClass: 'el-button--ceibs'
          }).then(() => {
            this.$store.dispatch('removeCurrentApplyId')
            this.reload()
          })
          this.disabled = true
        }
        this.formData = applyVo
        this.hasStudentInfo = applyVo.hasStudentInfo === 'Y'
        this.drawerFileList.splice(0)
        if (applyVo.idPhotoList && applyVo.idPhotoList.length > 0) {
          applyVo.idPhotoList.forEach(photo => {
            getFile(photo).then(blob => {
              this.drawerFileList.push({
                ...photo,
                name: photo.fileName,
                url: window.URL.createObjectURL(new Blob([blob]))
              })
            })
          })
        }
      })
    },
    beforeUpload (file) {
      if (!checkImgType(file)) {
        this.$message.error(this.$t('lang.confirmInfo.upload.pleaseUploadImage'))
        return false
      }
    },
    doUploadIdPhoto1 (param) {
      uploadFile(param.file, 'APPLY_ID_PHOTO').then(res => {
        this.upload.idPhoto1 = res.data
        getFileByFileUrl(res.data).then(file => {
          if (!file) return
          this.upload.idPhoto1Src = window.URL.createObjectURL(new Blob([file]))
        })
      })
    },
    doUploadIdPhoto2 (param) {
      uploadFile(param.file, 'APPLY_ID_PHOTO').then(res => {
        this.upload.idPhoto2 = res.data
        getFileByFileUrl(res.data).then(file => {
          if (!file) return
          this.upload.idPhoto2Src = window.URL.createObjectURL(new Blob([file]))
        })
      })
    },
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && this.checkIdPhoto()) {
          this.submitApply()
        } else {
          return false
        }
      })
    },
    checkIdPhoto () {
      if (!this.hasStudentInfo) {
        if (!this.drawerFileList.length >= 1) {
          this.$message.error(this.$t('lang.confirmInfo.validate.pleaseUploadIdPhoto'))
          return false
        }
      }
      return true
    },
    submitApply () {
      submitAndCreateApply({
        ...this.formData,
        hasStudentInfo: this.hasStudentInfo ? 'Y' : 'N',
        idPhotoList: this.drawerFileList
      }).then(res => {
        this.$store.dispatch('setCurrentApplyId', res.data.id)
        this.$router.push('confirmPack')
      })
    },
    openDrawer () {
      this.drawerVisible = true
    },
    doUpload (param) {
      uploadFile(param.file, 'APPLY_ID_PHOTO').then(res => {
        getFileByFileUrl(res.data).then(file => {
          if (!file) return
          this.$message.success(this.$t('lang.common.uploadSuccess'))
          this.drawerFileList.push({
            ...res.data,
            name: res.data.fileName,
            url: window.URL.createObjectURL(new Blob([file]))
          })
        })
      })
    },
    onRemove (file, fileList) {
      this.drawerFileList = fileList
    },
    openPreview () {
      if (this.drawerFileList.length > 0) {
        this.previewVisible = true
      }
    }
  }
}
</script>

<style scoped>
/deep/ .el-form-item__label {
  color: #a2100e;
}

/deep/ .el-form-item__content {
  text-align: left;
}

.uploadtitle {
  color: #a2100e;
  font-size: 14px;
  margin-bottom: 15px;
  text-align: left;
}

.upload-card {
  height: 318px;
  box-shadow: inset 1px 0px 50px 20px rgb(136 136 136 / 47%);
  overflow: visible;
}

.uploadicon {
  font-size: 12px;
  color: #5b5b5b;
}

.uploadicon .icon {
  font-size: 50px;
  color: #a2100e;
  margin-left: -10px;
}

.picnumber {
  font-size: 28px;
  font-family: Arial, Helvetica, sans-serif;
  color: #5b5b5b;
  font-weight: bold;
  position: absolute;
  bottom: 0;
  margin-left: 0px
}

.picnumber span {
  font-size: 55px;
  margin-left: 10px;
}

.photocard {
  height: 120px;
  border-radius: 10px;
  box-shadow: 1px 0px 18px 3px rgb(0 0 0 / 21%);
  display: flex;
  align-items: center;
  position: relative;
  overflow: visible;
}

.photocard i {
  font-size: 30px;
  position: absolute;
  right: -15px;
  top: -15px;
  color: #646464;
  cursor: pointer;
}

/deep/ .avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: visible;
  width: 100%
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100%;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.photocard i.avatar-uploader-icon {
  top: 0;
  right: 0;
}

.id-photo-label:before {
  content: '*';
  color: #F56C6C;
  margin-right: 4px;
}
</style>>
